import { X } from "lucide-react";

const FilterPill = ({ label, onRemove, color = "slate" }) => {
  const colorClasses = {
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    violet: "bg-violet-50 text-violet-700 border-violet-200",
    orange: "bg-orange-50 text-orange-700 border-orange-200",
    sky: "bg-sky-50 text-sky-700 border-sky-200",
    slate: "bg-slate-100 text-slate-700 border-slate-200",
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 border rounded-full text-sm font-medium ${colorClasses[color]}`}>
      {label}
      <button
        onClick={onRemove}
        className="hover:bg-black/10 rounded-full p-0.5 transition-colors"
        data-testid={`remove-filter-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </span>
  );
};

const ActiveFilters = ({
  selectedProducts,
  selectedIndustries,
  selectedUseCaseTypes,
  selectedMarkets,
  onRemoveProduct,
  onRemoveIndustry,
  onRemoveUseCaseType,
  onRemoveMarket,
  onClearAll
}) => {
  const hasFilters = selectedProducts.length > 0 || selectedIndustries.length > 0 || selectedUseCaseTypes.length > 0 || selectedMarkets.length > 0;

  if (!hasFilters) return null;

  const getProductColor = (product) => {
    if (product === "DataHub") return "emerald";
    if (product === "AI Forecasts") return "violet";
    if (product === "Dispatch Solutions") return "orange";
    return "sky";
  };

  return (
    <div className="flex flex-wrap items-center gap-2 mt-4" data-testid="active-filters">
      <span className="text-sm text-slate-500 mr-1">Active filters:</span>
      
      {selectedProducts.map((product) => (
        <FilterPill
          key={`product-${product}`}
          label={product}
          onRemove={() => onRemoveProduct(product)}
          color={getProductColor(product)}
        />
      ))}
      
      {selectedIndustries.map((industry) => (
        <FilterPill
          key={`industry-${industry}`}
          label={industry}
          onRemove={() => onRemoveIndustry(industry)}
          color="slate"
        />
      ))}
      
      {selectedUseCaseTypes.map((type) => (
        <FilterPill
          key={`type-${type}`}
          label={type}
          onRemove={() => onRemoveUseCaseType(type)}
          color="slate"
        />
      ))}
      
      {selectedMarkets.map((market) => (
        <FilterPill
          key={`market-${market}`}
          label={market}
          onRemove={() => onRemoveMarket(market)}
          color="sky"
        />
      ))}

      <button
        onClick={onClearAll}
        className="text-sm text-[#FF6F40] hover:underline ml-2"
        data-testid="clear-all-filters-btn"
      >
        Clear all
      </button>
    </div>
  );
};

export default ActiveFilters;
